import { createReducer, on } from '@ngrx/store';
import { ContactHistoryActions, RouterActions } from '@actions/index'
import { ContactHistoryModel } from '@models/index'
import { emptyContactHistoryModel } from '@utilities/data-utils';

export interface State {
    contactHistory: ContactHistoryModel;
    error: string;
}

const initialState: State = {
    contactHistory:  emptyContactHistoryModel(),
    error: "",
};

export const reducer = createReducer(
    initialState,
    on(ContactHistoryActions.searchContactHistorySuccess, (state, { data }) => ({ ...state, contactHistory: ({...data
        , campaigns: 
        data.campaigns.map((campaign, index)=>
            ({
                ...campaign,
                name: index === 0
                ? campaign.name
                : data.campaigns[index - 1].campaignId === campaign.campaignId
                    ? ''
                    : campaign.name
            })
        )
    })})),
    on(ContactHistoryActions.restartCampaignContactHistorySuccess, (state, { contactHistory }) => ({ ...state, contactHistory })),
    on(ContactHistoryActions.contactHistoryError, (state, { error }) => ({ ...state, error })),
    on(RouterActions.navigateAuth, () => ({ ...initialState })),

);


export const getContactHistory = (state: State) => state.contactHistory;
export const getError = (state: State) => state.error;